<div class="sfondo">
  <div class="box" *ngIf="isLinkValid">
    <p>Clicca il bottone per scaricare l'ebook</p>
    <button class="its-button" (click)="download()" [disabled]="isDownloading">
      <span *ngIf="!isDownloading">Download ebook</span>
      <span *ngIf="isDownloading == true">
        <mat-icon><mat-spinner color="warn" diameter="20">
          </mat-spinner></mat-icon>
      </span>
    </button>
  </div>
  <div class="box" *ngIf="!isLinkValid">
    <p style="margin: 0;">Il link è scaduto contatta l'assistenza <br><a
        href="mailto:info@itsdesifit.com">info@itsdesifit.com</a></p>
  </div>
</div>
